/** Controlled vocabulary only. Never alter identifiers, units or advanced query syntax. */
export function normalizeGuardianSearchQuery(input) {
  const original = String(input ?? '');
  if (/["':=]/u.test(original)) return original;
  const words = original.trim().split(/\s+/u);
  const normalized = words.map(word => word.normalize('NFD').replace(/[\u0300-\u036f]/gu, '').toLowerCase());
  const phrases = [
    ['actuadores de compuertas', 'damper actuators'],
    ['actuador de compuerta', 'damper actuator'],
    ['actuadores de valvulas', 'valve actuators'],
    ['actuador de valvula', 'valve actuator'],
    ['bombas de calor', 'heat pumps'],
    ['bomba de calor', 'heat pump'],
    ['motor de ventilador', 'fan motor'],
    ['compresores', 'compressors'], ['compresor', 'compressor'],
    ['actuadores', 'actuators'], ['actuador', 'actuator'],
    ['filtros', 'filters'], ['filtro', 'filter'],
    ['valvulas', 'valves'], ['valvula', 'valve'],
  ];
  const result = [];
  let changed = false;
  for (let i = 0; i < words.length;) {
    const phrase = phrases.find(([source]) => {
      const parts = source.split(' ');
      return parts.every((part, offset) => normalized[i + offset] === part);
    });
    if (phrase) {
      result.push(phrase[1]);
      i += phrase[0].split(' ').length;
      changed = true;
    } else {
      result.push(words[i]);
      i++;
    }
  }
  return changed ? result.join(' ') : original;
}

if (typeof document !== 'undefined') {
  const current = new URL(location.href);
  if (/\/search\/?$/u.test(current.pathname)) {
    const original = current.searchParams.get('q') || '';
    const normalized = normalizeGuardianSearchQuery(original);
    if (normalized !== original) {
      current.searchParams.set('guardian_original_query', original);
      current.searchParams.set('q', normalized);
      location.replace(current.href);
    } else {
      const prior = current.searchParams.get('guardian_original_query');
      const note = document.querySelector('[data-guardian-search-note]');
      if (prior && note instanceof HTMLElement) {
        note.textContent = note.dataset.label.replace('[original]', prior).replace('[catalog]', original);
        note.hidden = false;
      }
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const target = new URL(form.action, location.origin);
    if (target.origin !== location.origin || !/\/search\/?$/u.test(target.pathname)) return;
    const query = form.querySelector('input[name="q"]');
    if (!(query instanceof HTMLInputElement)) return;
    const original = query.value;
    const normalized = normalizeGuardianSearchQuery(original);
    if (normalized === original) {
      form.querySelector('input[name="guardian_original_query"]')?.remove();
      return;
    }
    query.value = normalized;
    let originalField = form.querySelector('input[name="guardian_original_query"]');
    if (!originalField) {
      originalField = document.createElement('input');
      originalField.type = 'hidden';
      originalField.name = 'guardian_original_query';
      form.append(originalField);
    }
    originalField.value = original;
  }, true);
}
